import React from 'react';
import { SvgIcon } from '@mui/material';

export default function ClockIcon({
  strokeColor = '#ffffff',
  fillColor = 'currentColor',
  ...props
}) {
  return (
    <SvgIcon viewBox="0 0 16 17" sx={{ width: 16, height: 17 }} {...props}>
      <rect y="0.5" width="16" height="16" rx="4" fill={fillColor} />
      <path
        d="M7.33203 4.5V9.83333H11.332"
        stroke={strokeColor}
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
